<template src="./html/Edit.html"></template>

<script>
	import Multiselect from 'vue-multiselect'
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import DepartmentModal from './../../../departments/views/Modal.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'multiselect': Multiselect,
			'department-modal': DepartmentModal,
		},
		data () {
			return {
				resource: 'teams',
				item: null,

				users: null,
				departments: null,
				department: null,
				newUser: null,
				newUsers: [],
				department_users: [],

				options: [],
				isLoading: false,
			}
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getItem()
				this.getUsers()
			},
			removeUser(user) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.post('admin/projects/'+that.resource+'/'+that.item.id+'/remove/user', user)
							.then(response => {
								if(response.body.type == 'success') {
									let index = that.item.users.indexOf(user)
									that.item.users.splice(index, 1)
								}
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
							}).catch(function(response) {
								console.log(response)
								swal({
									title: response.body.statusText,
									text: response.body.body,
									type: "warning"
								});
							})
						})
					}
				}]).catch(swal.noop)
			},
			dateAvailable: function (comment) {
				if(comment) {
					var start = moment(comment.start_date).format('DD/MM/YY')
					var end = moment(comment.end_date).format('DD/MM/YY')
					return start + ' - ' + end
				}
			},
			addUser() {
				if(this.newUser) {
					this.newUsers.push(this.newUser)
					let index = this.department_users.indexOf(this.newUser)
					this.department_users.splice(index, 1)
					this.newUser = null
				}
			},
			quitUser(user) {
				let index = this.newUsers.indexOf(user)
				this.newUsers.splice(index, 1)
			},
			storeUsers() {
				var loading = Ladda.create(this.$refs.btnStore)
				loading.start()
				if(this.newUsers.length) {
					var data = {
						users: this.newUsers,
					}
					this.$http.post('admin/projects/'+this.resource+'/'+this.item.id+'/add/users', data)
					.then(response => {
						loading.stop()
						swal(response.body.title, response.body.text, response.body.type)
						this.closeModal('modal-add-user')
						this.newUsers = []
						this.department = null
						this.options = []
						this.getItem()
					}).catch(function(response) {
						console.log(response)
						loading.stop()
						this.closeModal('modal-add-user')
						this.newUsers = []
						this.department = null
						this.getItem()
					})
				}
			},
			openModal(id) {
				$('#'+id).modal('show')
			},
			closeModal(id) {
				$('#'+id).modal('hide')
			},
			getUsers() {
				this.$http.get('admin/users')
				.then(response => {
					this.users = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getItem() {
				var id = this.$route.params.id
				if(id) {
					this.$http.get('admin/projects/'+this.resource+'/'+id+'/edit')
					.then(response => {
						this.item = response.body['team']
						this.departments = response.body['departments']
					}).catch(function(response) {
						console.log(response)
					})
				}
			},
			update() {
				var loading = Ladda.create(this.$refs.btnUpdate)
				loading.start()
				this.$http.put('admin/projects/'+this.resource+'/' + this.$route.params.id, this.item)
				.then(response => {
					loading.stop()
					swal(response.body.title, response.body.text, response.body.type)
				}).catch(function(response) {
					console.log(response)
					loading.stop()
				})
			},
			openPopoverDate(id) {
				var popover = $('#popover-'+id)
				popover.popover('toggle')
			},
			dateUnavailable (unavailable) {
				if(unavailable.length) {
					for (var i = 0; i < unavailable.length; i++) {
						var element = unavailable[i]
						var start = moment(element.start_date)
						var end = moment(element.end_date)
						if(moment().isBetween(start, end)) {
							return start.format('DD/MM/YYYY - H:mm') + ' | ' + end.format('DD/MM/YYYY - H:mm')
						}
					}
				}
			},
			typeUnavailable(unavailable) {
				if(unavailable.length) {
					for (var i = 0; i < unavailable.length; i++) {
						var element = unavailable[i]
						var start = moment(element.start_date)
						var end = moment(element.end_date)
						if(moment().isBetween(start, end)) {
							return element.type
						}
					}
				}
			},
			search(query) {
				if(query) {
					this.isLoading = true
					var data = {
						query: query,
						filter: {
							department_id: null,
							team_id: null,
						}
					}

					if(this.item.project) {
						data.filter.team_id = this.item.project.team_id
					}

					if(this.department) {
						data.filter.department_id = this.department.id
					}

					this.$http.post('admin/users/search', data)
					.then(response => {
						this.isLoading = false
						this.options = response.body
						this.filterUsers()
					}).catch(function(response) {
						this.isLoading = false
						console.log(response)
					})
				}
			},
			filterUsers () {
				if(this.item) {
					if(this.item.users) {
						if(this.item.users.length) {
							if(this.options) {
								if(this.options.length) {
									var that = this
									this.item.users.map(function(e) {
										for (var i = 0; i < that.options.length; i++) {
											var element = that.options[i]
											if(element.id == e.id) {
												that.options.splice(i, 1)
											}
										}
									})
								}
							}
						}
					}
				}
			}
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/teams/views/Edit.vue